<!-- Button to trigger modal -->
<button
  class="btn btn-outline-dark btn-sm px-3 fw-semibold rounded rounded-pill position-relative bg-white text-dark w-100"
  (click)="openMap()"
>
  Elegir asientos
</button>

<div
  [ngClass]="{ 'd-none': !isOpen }"
  class="three-d-map-backdrop"
></div>

<!-- 3D MAP CONTAINER START -->
<div [ngClass]="{ 'd-none': !isOpen }" class="three-d-map-container">
  <div class="three-d-map-header">
    <div>
      <p>{{ isPanoViewActive ? "Seleccionar asientos" : "Seleccionar sección" }}</p>
      <p>{{ isPanoViewActive ? "Selecciona tus asientos preferidos" : "Selecciona una sección para luego seleccionar tu asiento"}}</p>
    </div>
    <span
      (click)="closeMap()"
      class="material-symbols-outlined icon-button cursor-pointer close-btn"
    >
      close
    </span>
  </div>
  <div class="three-d-map-body">
    <div class="three-d-map-body-view">
      <div #stadiumView id="stadiumView"></div>
      <div #panoDisplay id="panoDisplay"></div>
      <div
        id="tooltip"
        style="position: absolute; background-color: white"
        class="p-2"
      ></div>
      <div class="three-d-map-seats" *ngIf="isPanoViewActive">
      <p>Asientos Elegidos</p>
      <div class="three-d-map-seats-list">
      <app-threed-seat-item
      [seat]="seat"
      *ngFor="let seat of seats"
      ></app-threed-seat-item>
      </div>
      </div>
    </div>
  </div>
  <div class="three-d-map-footer" *ngIf="isPanoViewActive">
    <div class="go-back-btn" (click)="goBack()">
      <span class="material-symbols-outlined icon-button cursor-pointer">
        arrow_back
      </span>
      Atrás
    </div>
    <button [disabled]="!seats.length" (click)="onAccept()" class="map-btn inter-500">Continuar</button>
  </div>
</div>
<!-- 3D MAP CONTAINER END -->

<div
  class="alert"
  role="alert"
  id="3d-seats-taken-alert"
  style="
    position: fixed;
    display: none;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
  "
></div>
